export default {
  notifications: {
    fetching: false,
    fetched: false,
    submitting: false,
    submitted: false,
    data: null
  },
  error: null
}
